import type { GButtonProps } from '~/presentation/ui';

export interface GCGActionButtonProps extends Pick<
  GButtonProps,
  'variant' | 'size' | 'stopPropagation'
> {
  isShowText?: boolean;
}
export interface GCampaignActionButtonProps extends Pick<
  GButtonProps,
  'variant' | 'size' | 'stopPropagation'
> {
  isShowText?: boolean;
}

export enum ICampaignLocked {
  REACHED_LIMIT = 'REACHED_LIMIT',
  OVER_LIMIT = 'OVER_LIMIT',
  BLOCKED_APP = 'BLOCKED_APP',
}
